<div>
    <form @submit.prevent="search" class="vl-form aeg-u-bg-alt aeg-u-box-padding">
        <div class="aeg-u-bg-white aeg-u-box-padding">
            <div class="aeg-flex-rows-layout">
                <div class="aeg-label-above-layout">
                    <label for="identifier">Identificator (KBO, OVO, OrgCode of SubjectId)</label>
                    <InputText id="identifier" name="identifier" v-model="identifier" autocomplete="off"/>
                </div>
                <div class="aeg-flex-row">
                    <div class="aeg-label-above-layout">
                        <label for="name">Naam</label>
                        <InputText id="name" name="name" v-model="name" autocomplete="off"/>
                    </div>
                    <div class="aeg-label-above-layout">
                        <label for="service">Service</label>
                        <Select
                            id="service" name="service"
                            v-model="selectedService"
                            :options="serviceOptions"
                            option-label="label"
                            option-value="value"
                        />
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

